var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenumobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 12.75C0.871528 12.75 0.624306 12.65 0.425 12.45C0.225 12.2507 0.125 12.0035 0.125 11.7083C0.125 11.4132 0.225 11.166 0.425 10.9667C0.624306 10.7667 0.871528 10.6667 1.16667 10.6667H17.8333C18.1285 10.6667 18.3757 10.7667 18.575 10.9667C18.775 11.166 18.875 11.4132 18.875 11.7083C18.875 12.0035 18.775 12.2507 18.575 12.45C18.3757 12.65 18.1285 12.75 17.8333 12.75H1.16667ZM1.16667 7.54167C0.871528 7.54167 0.624306 7.44167 0.425 7.24167C0.225 7.04236 0.125 6.79514 0.125 6.5C0.125 6.20486 0.225 5.95729 0.425 5.75729C0.624306 5.55799 0.871528 5.45833 1.16667 5.45833H17.8333C18.1285 5.45833 18.3757 5.55799 18.575 5.75729C18.775 5.95729 18.875 6.20486 18.875 6.5C18.875 6.79514 18.775 7.04236 18.575 7.24167C18.3757 7.44167 18.1285 7.54167 17.8333 7.54167H1.16667ZM1.16667 2.33333C0.871528 2.33333 0.624306 2.23368 0.425 2.03437C0.225 1.83437 0.125 1.58681 0.125 1.29167C0.125 0.996528 0.225 0.748959 0.425 0.548959C0.624306 0.349653 0.871528 0.25 1.16667 0.25H17.8333C18.1285 0.25 18.3757 0.349653 18.575 0.548959C18.775 0.748959 18.875 0.996528 18.875 1.29167C18.875 1.58681 18.775 1.83437 18.575 2.03437C18.3757 2.23368 18.1285 2.33333 17.8333 2.33333H1.16667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenumobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menumobile.5c004bac72f22c3119f05e09c8d3bf79.svg";